import { render, staticRenderFns } from "./ShortcutOverview.vue?vue&type=template&id=0acfab51&"
import script from "./ShortcutOverview.vue?vue&type=script&lang=js&"
export * from "./ShortcutOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acfab51')) {
      api.createRecord('0acfab51', component.options)
    } else {
      api.reload('0acfab51', component.options)
    }
    module.hot.accept("./ShortcutOverview.vue?vue&type=template&id=0acfab51&", function () {
      api.rerender('0acfab51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings/ShortcutOverview.vue"
export default component.exports